<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.contentExportOverlay.stepFormat.title') }}
        </page-title>

        <form-wrap>
          <form-field-set :should-show-border="false">
            <select-input
              v-model="format"
              :label="$t('c.contentExportOverlay.stepFormat.form.label.format')"
              :options="formatOptions"
              :empty-label="null"
              name="format"
              direction="vertical"
            />
          </form-field-set>
        </form-wrap>
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.contentExportOverlay.stepFormat.btnNext'"
              :is-disabled="isInvalid"
              @click="nextStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'ContentExpoerStepFormat',

  mixins: [PageMixin, FormMixin],

  computed: {
    ...mapGetters({
      formatOptions: 'contentExport/formatOptions',
    }),

    format: {
      get () { return this.$store.state.contentExport.form.format },
      set (value) { this.$store.dispatch('contentExport/setFormat', value) }
    },

    isInvalid () {
      return this.format === null
    }
  },

  methods: {
    ...mapActions({
      nextStep: 'contentExport/nextStep'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/export/steps/Format.vue